import React, { useEffect, useState } from "react";

import { GlobalStore } from "../../stores/global";

import symptomsOfVideoAndDoctorMY from "../../stores/video-and-doctor-MY.json";
import symptomsOfVideoAndDoctorSG from "../../stores/video-and-doctor-SG.json";

const SymptomSearch = ({ content }) => {
  const { currentCountryCode } = GlobalStore.useState(c => c);

  const { subtitle, title, featureHeader, searchHeader, searchLabel, searchPlaceholder, commonSymptoms, contentAlign } =
    content;
  const [symptoms, setSymptoms] = useState(symptomsOfVideoAndDoctorSG.symptoms);

  useEffect(() => {
    switch (currentCountryCode) {
      case "SG":
        setSymptoms(symptomsOfVideoAndDoctorSG.symptoms);
        break;
      case "MY":
        setSymptoms(symptomsOfVideoAndDoctorMY.symptoms);
        break;
      default:
        setSymptoms(symptomsOfVideoAndDoctorSG.symptoms);
    }
  }, [currentCountryCode]);

  const search = searchText => {
    let result = symptomsOfVideoAndDoctorSG.symptoms.filter(
      symptom => symptom.title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    );
    setSymptoms(result);
  };

  return (
    <div id="SymptomSearch" style={{ "--main-align": contentAlign }}>
      <div className="wrap">
        <div className="headerContainer">
          <div className="subtitle">{subtitle}</div>
          <div className="title">{title}</div>
        </div>
        <div className="featureContainer">
          <div className="featureheader">{featureHeader}</div>
        </div>
        <div className="symptomContainer common">
          {commonSymptoms &&
            commonSymptoms.symptoms.map((symptom, index) => (
              <div key={index} className="symptom" onClick={() => {}}>
                {symptom.title}
              </div>
            ))}
        </div>
        <div className="searchContainer">
          <div className="searchHeader">{searchHeader}</div>
          <div className="search">
            <div className="searchLabel">{searchLabel}</div>
            <input
              type="text"
              className="searchInput"
              placeholder={searchPlaceholder}
              onChange={e => search(e.target.value)}
            />
          </div>
        </div>
        <div className="symptomContainer full-list">
          {symptoms &&
            symptoms.map((symptom, index) => (
              <div key={index} className="symptom" onClick={() => {}}>
                {symptom.title}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SymptomSearch;
